import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useField } from "formik";

// component
import LdsValidationError from "../LdsValidationError";
import { ReactLoaderSpinner } from "../ReactLoaderSpinner";

// services
import { useGetSpecialtiesQuery } from "../../store/services/specialtiesServerApi";

export const SpecialityDropDown = ({ label, labelRequired, name, error }) => {
  const [field, meta, helpers] = useField(name);

  // useState
  const [specialityOptions, setSpecialityOptions] = useState([]);

  // RTK call
  const { isLoading, data: { data: specialityList = [] } = {} } =
    useGetSpecialtiesQuery();

  useEffect(() => {
    if (specialityList?.length) {
      const stateOptions = specialityList?.map(
        ({ code: value, name: label }) => ({
          value,
          label,
        })
      );
      setSpecialityOptions(stateOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialityList]);

  return (
    <>
      {isLoading && <ReactLoaderSpinner />}
      {label && (
        <label className="lds-form-label">
          {label} {labelRequired && <span className="required"> *</span>}
        </label>
      )}
      <Select
        name={name}
        value={field.value}
        options={specialityOptions}
        onChange={(value) => helpers.setValue(value)}
        onBlur={() => helpers.setTouched(true)}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: error ? "red" : "grey",
          }),
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: "#d9e1ea",
            primary: "#7393B3",
          },
        })}
      />
      {error && <LdsValidationError id="errstate">{error}</LdsValidationError>}
    </>
  );
};
